import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Asset } from 'src/models';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { postPreorder } from '../../../api/stoApi';
import { LoadingButton } from '@mui/lab';
import { generalStore } from '../../../stores/GeneralStore';

interface Props {
  open: boolean;
  asset: Asset;
  handleClose: () => void;
  triggerRefresh: () => void;
}

export const PreorderDialog: FC<Props> = ({ open, asset, handleClose, triggerRefresh }) => {
  const [t] = useTranslation();
  const [isLoading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await postPreorder(asset.id);
      generalStore.setInfoMsg(t('dashboard.assets.dialog.preorder.success'));
      handleClose();
      triggerRefresh();
    } catch (error) {
      generalStore.setInfoMsg(t('dashboard.assets.dialog.preorder.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('dashboard.assets.dialog.preorder.title')}</DialogTitle>
      <DialogContent>
        <Typography>{t('dashboard.assets.dialog.preorder.description')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} color="inherit" disableElevation onClick={handleClose}>
          {t('dashboard.assets.dialog.preorder.cancel')}
        </Button>
        <LoadingButton variant="contained" disableElevation color="primary" onClick={submit} loading={isLoading}>
          {t('dashboard.assets.dialog.preorder.start')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
